import { SelectHTMLAttributes } from 'react';

interface Props extends SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
  name: string;
  register?: any;
  errors?: any;
  required?: boolean;
  options: { value: string; label: string }[];
  leftIcon?: React.ReactNode;
}

const Select = (props: Props) => {
  const { label, name, register, required, errors, options, leftIcon, ...rest } = props;
  const error = errors ? errors[name] : null;

  return (
    <div className="relative w-full">
      <div className="relative">
        {leftIcon && (
          <div className="absolute inset-y-0 left-0 flex items-center pl-4 pointer-events-none">{leftIcon}</div>
        )}
        <select
          {...register(name, { required })}
          {...rest}
          defaultValue=""
          className={`block w-full text-base appearance-none focus:outline-none bg-white ${
            leftIcon ? 'pl-12' : 'pl-4'
          } pr-10 py-4 border border-blue-300 rounded-md text-gray-500`}
        >
          <option value="" disabled>
            {label}
          </option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <div className="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none">
          <svg
            className="w-5 h-5 text-gray-500"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </div>
      </div>
      {error && <p className="mt-1 text-sm text-red-500">{error.message}</p>}
    </div>
  );
};

export default Select;
